import Notifier from 'common/helpers/Notifier';
import {
  useClient,
  useCurrentEmployee,
  useProvider,
} from '../context/InteractionsContext';
import { useCreateRecord, useInvalidateQueries } from './APIHooks';
import { useInteractionConcepts } from './useInteractionConcepts';

export const useCreateProcedure = () => {
  const client = useClient();
  const currentEmployee = useCurrentEmployee();
  const provider = useProvider();
  const { procedureConcepts } = useInteractionConcepts();
  const invalidateQueries = useInvalidateQueries();
  const { createRecord } = useCreateRecord('procedure', {
    mutationConfig: {
      onError: () => Notifier.dispatch('error', 'Failed to create procedure...'),
      onSettled: () => invalidateQueries('interaction'),
    },
  });
  return async ({
    interactionId,
    codeConceptId,
    note,
    performed_start_time,
    performed_end_time,
    quantity_value,
  }) => {
    const employeeId = currentEmployee?.id;

    return createRecord({
      interaction: interactionId,
      person: client?.id,
      recorded_by: employeeId,
      service_provider: provider?.id,
      code_concept: codeConceptId,
      state_concept: procedureConcepts?.stateConceptId,
      unit_concept: procedureConcepts?.unitConceptId,
      note: note || undefined,
      performed_start_time,
      performed_end_time,
      quantity_value,
    });
  };
};
